import type { Store } from './Store';

/** How many times something has been done today (for "N per day" limits). */
export function usedToday(store: Store, key: string): number {
  const v = store.flag(key);
  if (typeof v !== 'string') return 0;
  const [day, n] = v.split(':').map(Number);
  return day === store.day ? (n ?? 0) : 0;
}

export function useToday(store: Store, key: string, n = 1): void {
  store.setFlag(key, `${store.day}:${usedToday(store, key) + n}`);
}

/** Night owls: anything between 7 PM and 3 AM belongs to the night it started. */
export function nightOf(store: Store): number {
  return store.minutes >= 19 * 60 ? store.day : store.day - 1;
}

export function usedTonight(store: Store, key: string): number {
  const v = store.flag(key);
  if (typeof v !== 'string') return 0;
  const [night, n] = v.split(':').map(Number);
  return night === nightOf(store) ? (n ?? 0) : 0;
}

export function useTonight(store: Store, key: string, n = 1): void {
  store.setFlag(key, `${nightOf(store)}:${usedTonight(store, key) + n}`);
}
